import { ColumnConfig, CustomersColumnKey } from '../../model';

export const customerConfig: Record<CustomersColumnKey, ColumnConfig> = {
  // checkBox: {
  //   name: '',
  //   field: 'checkbox',
  //   isCheckboxField: false,
  // },
  // slNumber: { name: 'S.No' },
  customerSelection: {
    name: 'Customer',
    field: 'checkboxText',
    isCheckboxField: true,
    isComponent: true,
  },
  customerName: {
    name: 'Customer Name',
    field: 'avatarNameStatus',
    isComponent: true,
  },
  // status: {
  //   name: 'Status',
  //   field: 'customerListStatusTag',
  // },
  customerCode: { name: 'Customer Code', field: 'component' },
  routes: {
    name: 'Routes',
    field: 'component',
    isComponent: true,
  },
  segments: {
    name: 'Segments',
    field: 'component',
    isComponent: true,
  },
  // priceList: {
  //   name: 'Price List',
  //   field: 'component',
  //   isComponent: true,
  // },
  // mobileNumber: {
  //   name: 'Mobile Number',
  // },
  // numberOfDivisions: { name: 'No. of Divisions', alignment: 'flex-end' },
  // dlNumber: {
  //   name: 'DL Number',
  // },
  // gstNumber: {
  //   name: 'GST Number',
  // },
  // groups: {
  //   name: 'Groups',
  //   field: 'customerGroups',
  // },
  teamMember: {
    name: 'Team Members',
    alignment: 'flex-end',
    field: 'addAction',
  },
  creditLimit: {
    name: 'Credit Limit',
    alignment: 'flex-end',
    isAdditional: true,
    isVisible: false,
  },
  outstanding: {
    name: 'Outstanding',
    alignment: 'flex-end',
    isAdditional: true,
    isVisible: false,
  },
  city: {
    name: 'City',
    alignment: 'flex-start',
    isAdditional: true,
    isVisible: false,
  },
  action: {
    name: 'Actions',
    field: 'customerListActions',
    alignment: 'flex-end',
    permissions: ['order_write'],
  },
};
